import { render, staticRenderFns } from "./BankTransferAddPage.vue?vue&type=template&id=7ce8e042&"
import script from "./BankTransferAddPage.vue?vue&type=script&lang=js&"
export * from "./BankTransferAddPage.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferAddPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports